<div class="h-full flex flex-col p-4">
  <div class="flex flex-col flex-1 min-h-0">
    @if (showContextDocuments()) {
      <div
        class="relative bg-black/10 p-2 text-white flex justify-between items-center text-xs border-b-[0.5px] border-b-neutral-700"
        data-testid="context-documents-bar"
      >
        <div class="flex gap-2 items-center">
          <span class="text-neutral-300">{{ contextDocumentsStatus() }}:</span>
          <span class="font-bold">{{ contextDocumentsName() }}</span>
        </div>

        @if (selectedDocument()) {
          <button
            [disabled]="isCloseContextDocumentDisabled()"
            (click)="onContextDocumentCloseClick()"
            class="group cursor-pointer disabled:cursor-not-allowed"
            data-testid="context-document-close-button"
          >
            <flx-icon
              name="cross"
              class="group-disabled:text-neutral-400"
            />
          </button>
        }

        @if (isUploadingDocuments()) {
          <p-progressBar
            class="absolute left-0 right-0 h-[1px] bottom-0 overflow-hidden"
            mode="indeterminate"
            data-testid="context-document-upload-progress"
          />
        }
      </div>
    }
    <div
      class="mb-[0.5px] flex-1 min-h-0"
      data-testid="scrollable-content"
    >
      <flx-ai-chat-history
        [messages]="messages()"
        data-testid="chat-history"
      />
    </div>
  </div>
  <div class="flex flex-col gap-2">
    <div class="flex justify-center items-center text-2xs text-neutral-400">
      AI might produce unexpected or inaccurate results
    </div>
    @if (showChatTypeArea()) {
      <div
        class="border-[0.5px] border-neutral-500 focus-within:border-yellow-500 rounded-lg p-4 flex-none scrollbar-dark transition-colors"
        data-testid="command-palette-type-area-container"
      >
        <flx-ai-type-area
          [hint]="typeAreaPlaceholder()"
          tabindex="0"
          data-testid="command-palette-type-area"
        />

        @if (showUploadedImages()) {
          @for (image of images(); track image) {
            <div class="pt-2">
              <div
                class="flex flex-col rounded-lg p-2 bg-black/30 gap-1 w-[112px] h-[142px] overflow-hidden"
                data-testid="uploaded-image"
              >
                <div class="relative overflow-hidden rounded-lg">
                  <p-image
                    [src]="image.src$ | async"
                    [alt]="image.name"
                    class="w-[96px] h-[108px]"
                    width="96px"
                    height="108px"
                    imageClass="min-w-[96px] w-auto min-h-[108px] h-auto object-cover"
                    data-testid="uploaded-image-preview"
                  />
                  <button
                    (click)="deleteFileFromContext(image.id)"
                    class="absolute right-1 bottom-1 h-5 w-5 flex justify-center items-center rounded-[6px] bg-black cursor-pointer"
                    data-testid="delete-uploaded-image-button"
                  >
                    <flx-icon
                      name="trash"
                      class="w-3 h-3 text-red-500"
                    />
                  </button>
                </div>
                <div
                  class="h-4 text-2xs leading-[8px] text-white truncate grow-0"
                  data-testid="uploaded-image-name"
                >
                  {{ image.name }}
                </div>
              </div>
            </div>
          }
        }

        @if (showUploadedBpmnFiles()) {
          @for (bpmn of bpmnFiles(); track bpmn) {
            <div class="pt-2">
              <div
                class="flex flex-col rounded-lg p-2 bg-black/30 gap-1 w-[112px] h-[142px] overflow-hidden"
                data-testid="uploaded-bpmn"
              >
                <div class="relative overflow-hidden rounded-lg">
                  <p-image
                    [alt]="bpmn.name"
                    class="w-[96px] h-[108px]"
                    src="./assets/bpmn_thumb_full.svg"
                    width="96px"
                    height="108px"
                    imageClass="min-w-[96px] w-auto min-h-[108px] h-auto object-cover"
                    data-testid="uploaded-bpmn-preview"
                  />
                  <button
                    (click)="deleteFileFromContext(bpmn.id)"
                    class="absolute right-1 bottom-1 h-5 w-5 flex justify-center items-center rounded-[6px] bg-black cursor-pointer"
                    data-testid="delete-uploaded-bpmn-button"
                  >
                    <flx-icon
                      name="trash"
                      class="w-3 h-3 text-red-500"
                    />
                  </button>
                </div>
                <div
                  class="h-4 text-2xs leading-[8px] text-white truncate grow-0"
                  data-testid="uploaded-bpmn-name"
                >
                  {{ bpmn.name }}
                </div>
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
